import React from 'react'
import { Skeleton } from '@material-ui/lab'

const LoaderCardView = ({ rowsNum }) => {
  let count = 0
  return [...Array(rowsNum)].map(() => (
    <div className="bg-white rounded-lg shadow p-10" key={`loader-${count++}`}>
      {/* Information */}
      <div className="w-full space-y-3">
        <Skeleton
          animation="wave"
          style={{ height: '54px', borderRadius: '.5rem' }}
        />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </div>
      {/* Title Body */}
      <div className="py-5 border-t-1 border-neutrals-200 space-y-3 mt-5">
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </div>
    </div>
  ))
}

export default LoaderCardView
